/**
 * #6526: a etapa do funil continua gravada como "Análise cadastral" (negociações, funil e
 * relatórios dependem desse texto), mas aparece na tela como "Validação de dados".
 * Use só para exibir; para comparar e gravar, continue usando o nome que vem do banco.
 *
 *   node --experimental-strip-types --test src/lib/__tests__/nomeEtapaNaTela.test.ts
 */
export const nomeEtapaNaTela = (nome: string | null | undefined): string => {
    if (!nome) return nome ?? '';
    return /^an[aá]lise cadastral$/i.test(nome.trim()) ? 'Validação de dados' : nome;
};
